import { Navigate, Outlet, useLocation } from 'react-router';
import { useSession } from './session';

/** Les pages de l'application exigent une session ; sinon, retour à la connexion avec la page demandée. */
export function RequireAuth() {
  const session = useSession();
  const location = useLocation();
  if (!session) return <Navigate to="/connexion" state={{ de: location.pathname }} replace />;
  return <Outlet />;
}
